import React, { useState, useEffect } from 'react';
import './sqHistory.css';
import Header from '../sharedFiles/header/header';
import Footer from '../sharedFiles/footer/footer';
import { useDispatch, useSelector } from 'react-redux';
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { useLocation, useNavigate } from 'react-router-dom';
import { GetSqHistory, GetSQItems } from '../API/API';
import { emptyCart, selectIsCartEmpty, selectUser, setCart } from '../ReduxStore/userReducer';
import { GetData } from '../API/getApi';
import CommonDynamicTable from '../sharedFiles/CommonDynamicTable/CommonDynamicTable';
import { PostData } from '../API/postApi';
import { TablePagination } from '@mui/material';
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SearchIcon from '@mui/icons-material/Search';
import { fetchSQItemByDocEntry } from '../ReduxStore/reduxThunk';
import dayjs from 'dayjs';
import SunspotLoader from "../sharedFiles/loader/loader";


const SqHistory = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [searchFields, setSearchFields] = useState({});
    const [filteredData, setFilteredData] = useState(data)
    const [showMessage, setShowMessage] = useState(true);
    const [displayedItems, setDisplayedItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const userData = useSelector(selectUser);
    const isCartEmpty = useSelector(selectIsCartEmpty);
    const databaseName = userData?.DatabaseName;
    const jwtToken = userData?.JwtToken;
    const accessLevel = userData?.AccessLevel;
    const SlpCode = userData?.slpCode;
    const [rowsPerPage, setRowsPerPage] = useState(12);
    const [totalCount, setTotalCount] = useState(0); // Total count of records
    const [page, setPage] = useState(0);
    const [showSearchBar, setShowSearchBar] = useState(true);
    const location = useLocation();
    const [selectedFilters, setSelectedFilters] = useState({});
    const [menuColumn, setMenuColumn] = useState('');
    const { additionalData, opportunityNos } = location.state || {};
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await GetData(
                `${GetSqHistory}${databaseName}&SlpCode=${SlpCode}&AccessLevel=${accessLevel}`,
                {
                    headers: {
                        wg_token: jwtToken,
                    },
                },
                dispatch,
                navigate
            );
            if (Array.isArray(response) && response?.length > 0) {
                setData(response);
                setTotalCount(response.length);
                const paginatedData = response.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
                setDisplayedItems(paginatedData);
            } else {
                setData([]);
                setDisplayedItems([]);
                setError('No data available');
            }
        } catch (err) {
            setError(err.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };
    // console.log("displayedItems :", displayedItems);
    // Call fetchData when the component mounts or dependencies change
    useEffect(() => {
        fetchData();
    }, [databaseName, SlpCode, jwtToken, dispatch, navigate]);

    // // Triggered when searchTerm changes
    // useEffect(() => {
    //     if (searchTerm) {
    //         const filteredData = data.filter(item => {
    //             return Object.keys(item).some(col =>
    //                 String(item[col]).toLowerCase().includes(searchTerm.toLowerCase())
    //             );
    //         });

    //         // Apply pagination on filtered data
    //         const paginatedFilteredData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    //         setDisplayedItems(paginatedFilteredData);
    //         setTotalCount(filteredData.length); // Update total count based on filtered data
    //     } else {
    //         // If no searchTerm, display paginated data from the original response
    //         const paginatedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    //         setDisplayedItems(paginatedData);
    //         setTotalCount(data.length); // Update total count based on original data
    //     }
    // }, [searchTerm, page, rowsPerPage, data]);

    const handleRowClick = async (item) => {
        setLoading(true);
        try {
            const response = await GetData(
                `${GetSQItems}${databaseName}&DocEntry=${item.DocEntry}`,
                {
                    headers: {
                        wg_token: jwtToken,
                    },
                },
                dispatch,
                navigate
            );
            if (Array.isArray(response) && response?.length > 0) {
                setData(response);
                setShowSearchBar(false);
                setDisplayedItems(response);
                setTotalCount(response.length);
                setPage(0);
                
            } else {
                setData([]);
                setDisplayedItems([]);
                setError('No data available');
            }
        } catch (err) {
            setError(err.message || 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };
    const handleHeaderClick = (col) => {
        // console.log("Clicked column:", col);

        // Format the column name from snake_case to Title Case
        const formattedColumnName = col.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

        // Add or update the input field dynamically for each column clicked
        setSearchFields(prevFields => {
            if (!prevFields[formattedColumnName]) {
                return { ...prevFields, [formattedColumnName]: '' };
            }
            return prevFields;
        });
        setShowMessage(false);
    };

    const handleSearchChange = (e, column) => {
        const value = e.target.value;
        // Update the active search field value
        setSearchFields(prevFields => {
            return { ...prevFields, [column]: value };  // Update the specific column's search term
        });
        // console.log("value", value);
    };
    useEffect(() => {
        setShowMessage(true);
        // Check if there's saved state in localStorage when navigating back
        const savedSearchFields = localStorage.getItem('searchFields');
        const savedFilteredData = localStorage.getItem('filteredData');

        if (savedSearchFields && savedFilteredData) {
            // Restore the saved search fields and filtered data
            setSearchFields(JSON.parse(savedSearchFields));
            setFilteredData(JSON.parse(savedFilteredData));

            // Optionally, clear localStorage after restoring the data
            localStorage.removeItem('searchFields');
            localStorage.removeItem('filteredData');
        }
    }, []);
    const handleMenuItemClick = (item) => {
        if (typeof item === 'object' && item.from && item.to) {
            // Date range filtering
            setSelectedFilters((prev) => ({
                ...prev,
                [menuColumn]: item,
            }));
        } else {
            setSelectedFilters((prev) => {
                const current = prev[menuColumn] || [];
                const isSelected = current.includes(item);

                // Update the filter values
                const updated = isSelected
                    ? current.filter(i => i !== item)
                    : [...current, item];

                const newFilters = {
                    ...prev,
                    [menuColumn]: updated,
                };

                // If all items are unchecked, remove the column filter
                if (updated.length === 0) {
                    delete newFilters[menuColumn];
                }

                return newFilters;
            });
        }
    };

    useEffect(() => {
        let currentData = data;
        // Apply search filters first (if any)
        if (Object.values(searchFields).some((val) => val.trim() !== '')) {
            currentData = currentData.filter((item) => {
                return Object.keys(searchFields).every((col) => {
                    const formattedColumnName = col.replace(/ /g, '_');
                    if (item.hasOwnProperty(formattedColumnName)) {
                        return String(item[formattedColumnName])
                            .toLowerCase()
                            .includes(searchFields[col].toLowerCase());
                    }
                    return true;
                });
            });
        }

        // Apply date range filters (if any)
        Object.keys(selectedFilters).forEach((col) => {
            const filterValue = selectedFilters[col];
            // 📅 Handle date range filters
            if (typeof filterValue === 'object' && filterValue?.from && filterValue?.to) {
                const fromDate = new Date(filterValue.from);
                const toDate = new Date(filterValue.to);
                currentData = currentData.filter((item) => {
                    const itemDate = new Date(item[col]);
                    return itemDate >= fromDate && itemDate <= toDate;
                });
            }
            // Handle checkbox filters (like docStatus)
            if (Array.isArray(filterValue)) {
                currentData = currentData.filter((item) => {
                    const normalizedCol = col.replace(/ /g, '_');
          const actualKey = Object.keys(item).find(k => k.toLowerCase() === normalizedCol.toLowerCase());

          if (!actualKey || typeof item[actualKey] === 'undefined') return true;
                    const itemStatus = item[actualKey];
                    return filterValue.includes(itemStatus);
                });
            }
        });

        // Save filtered data
        setFilteredData(currentData);
        setTotalCount(currentData.length);
        // Reset to page 0 if data shrinks below current page
        // if (currentData.length <= page * rowsPerPage) {
        //     setPage(0);
        // }
        // Slice for pagination
        setDisplayedItems(currentData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));

    }, [searchFields, data, page, rowsPerPage, selectedFilters]);

    const handleRemoveItem = (columnName) => {
        //if didnot close specified field set this
        // if (columnName === 'Status') {
        //   return; 
        // }
        setSearchFields(prevFields => {
            const updatedFields = { ...prevFields };
            delete updatedFields[columnName]; // Remove the column from search fields
            return updatedFields;
        });
        if (Object.keys(searchFields).length === 0) {
            setShowMessage(true);
        }
    };

    //******** Pagination function will start here *************/

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        SlicedItem(newPage, rowsPerPage);  // Directly calling SlicedItem here for pagination
    };

    // Function to handle rows per page change
    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);  // Reset to first page
        SlicedItem(0, newRowsPerPage);  // Directly calling SlicedItem here
    };

    // Slicing logic for data pagination based on filtered data
    const SlicedItem = (page, rowsPerPage) => {
        setLoading(true);
        let dataToPaginate = filteredData; // Use filteredData for pagination
        // Paginate the filtered data (not the full dataset)
        const paginatedData = dataToPaginate.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        setDisplayedItems(paginatedData);
        setLoading(false);
    };

    // If loading or error, show respective message
    // if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    const handleBackToDashboard = () => {
        navigate("/DashBoard");
    };

    const handleBackToSQHis = () => {
        setShowSearchBar(true);
        fetchData();
    };

    const handleOpportunityClick = (opportunityNo) => {
        setShowSearchBar(true);
        navigate(`/Opportunity/${opportunityNo}`, { state: { additionalData: "SqHistory" } });
    };
    // const waitForCartToBeEmpty = () => {
    //     return new Promise((resolve) => {
    //         const interval = setInterval(() => {
    //             // Check if the cart is empty by looking at the isCartEmpty flag in the Redux state
    //            // This checks the current state
    //             if (isCartEmpty) {
    //                 clearInterval(interval); // Stop checking once the cart is empty
    //                 resolve(); // Resolve the promise when cart is emptied
    //             }
    //         }, 100); // Check every 50ms (you can adjust the frequency)
    //     });
    // };
    // console.log("isCartEmpty :", isCartEmpty);

    const handleNavSQ = async (item) => {
        const passValue = {
            additionalData: 'sqUpdate',
            opportunityNos: item.Opportunity_No,
        }
        localStorage.setItem('DocEntry', JSON.stringify(item));
        localStorage.setItem('additionalData', JSON.stringify(passValue));


        // console.log("item",item);
        try {
            // dispatch(emptyCart());
            // await waitForCartToBeEmpty();
            // dispatch(fetchSQItemByDocEntry(item, jwtToken));
            const response = await GetData(`${GetSQItems}${databaseName}&DocEntry=${item.DocEntry}`, {
                headers: {
                    'wg_token': jwtToken
                }
            });
            // console.log("dicsdcks",response);

            // const { additionalData } = location.state || {};
            // if (additionalData === 'sqUpdate') {
            const cartItemsObject = response.reduce((acc, item) => {
                acc[item.itemCode] = item;
                return acc;
            }, {});
            //   localStorage.setItem('cart',JSON.stringify(response))
            dispatch(setCart(response));
            //   console.log("displayedItems.LineId :",displayedItems.LineId);

            navigate(`/GetGroupItem`
                , {
                    state: {
                        opportunityNos: item.Opportunity_No,
                    }
                });

        } catch (error) {
            console.error("Error in handleNavSQ:", error);
        }
    };
    const handleResetSearch = () => {
        setSearchFields({})
     ;
      }
    
      const handleResetFilters = () => {
        setSelectedFilters({});
        // setDateRange({ from: null, to: null }); 
      };
    return (
        <div>
            <Header />
            {/* <div className='customerCreation historyMain'> */}
            <div className='dashBoardMain'>
                <div className="dashImage"></div>
                <div className="dashGradient"></div>
                {showSearchBar && (
                    <div className='sqHistorydiv'>
                        <div className='TopHisDiv'>
                            <div className=' d-flex col-4 me-4 me-xl-4 me-xxl-4 col-xl-4 col-xxl-5'>
                                <button onClick={handleBackToDashboard} className="backIcondiv">
                                    <ArrowCircleLeftIcon />

                                    <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">
                                        Dashboard
                                    </p>
                                </button>
                            </div>
                            <div className='opporTitle'>
                                <p>Sales Quotation History</p>
                            </div>
                        </div>
                        <div className='StepperGradient3'>
                            <div className="search-container">
                                {showMessage && (
                                    <div className="search-message">
                                        Click on a column header to start searching <SearchIcon />
                                    </div>
                                )}
                                {Object.keys(searchFields).map((columnName) => (
                                    <div key={columnName} className='searchfulldiv' >
                                        <input
                                            type="text"
                                            placeholder={`Search By ${columnName}`}
                                            value={searchFields[columnName]}
                                            onChange={(e) => handleSearchChange(e, columnName)}
                                            className="search-input"
                                        />
                                        <button className='removeIcon'
                                            onClick={() => handleRemoveItem(columnName)}  // Assuming handleRemoveItem clears that specific field
                                        >
                                            <HighlightOffIcon />
                                        </button>
                                    </div>
                                ))}
                                <div className="reset-buttons">
                                    {(Object.keys(searchFields).length > 0 || Object.keys(selectedFilters).length > 0) && (
                                        <>
                                            {Object.keys(searchFields).length > 0 && (
                                                <button
                                                    className="btnsubmitt btn btn-success btn-sm"
                                                    onClick={handleResetSearch}
                                                >
                                                    Reset Search
                                                </button>
                                            )}

                                            {Object.keys(selectedFilters).length > 0 && (
                                                <button
                                                    className="btnsubmitt btn btn-success btn-sm"
                                                    onClick={handleResetFilters}
                                                >
                                                    Reset Filters
                                                </button>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="opportable table-border">
                                <CommonDynamicTable
                                    data={displayedItems}
                                    dataType="sqhistory" // Your data type if want to hide some use this
                                    onEditRow={handleRowClick} // No editing functionality
                                    showEditButton={handleNavSQ} // No edit button
                                    handleOpportunityClick={handleOpportunityClick}
                                    accessLevel={accessLevel}
                                    Originaldata={data}
                                    filteredData={filteredData}
                                    menuColumn={menuColumn}
                                    setMenuColumn={setMenuColumn}
                                    handleMenuItemClick={handleMenuItemClick}
                                    selectedFilters={selectedFilters}
                                    handleHeaderClick={handleHeaderClick}
                                />
                            </div>
                        </div>
                    </div>)}
                {!showSearchBar && (
                    <div className='sqHistorydiv'>
                        <div className='TopHisDiv'>
                            <div className=' d-flex col-4 me-4 me-xl-4 me-xxl-4 col-xl-4 col-xxl-5'>
                                <button onClick={handleBackToSQHis} className="backIcondiv">
                                    <ArrowCircleLeftIcon />

                                    <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">
                                        SQ History
                                    </p>
                                </button>
                            </div>
                            <div className='opporTitle'>
                                <p>Sales Quotation History</p>
                            </div>
                        </div>
                        <div className='StepperGradient3'>
                            <div className="search-container "></div>
                            <div className="opportable table-border">
                                <CommonDynamicTable
                                    data={displayedItems}
                                    dataType="sqItemhistory" // Your data type if want to hide some use this
                                    //onEditRow={handleRowClick} // No editing functionality
                                    showEditButton={false} // No edit button
                                // handleOpportunityClick ={handleOpportunityClick}
                                />
                            </div>
                        </div>
                    </div>)}
                <div className="hispagination">
                    <TablePagination
                        component="div"
                        count={totalCount}  // Total records available
                        page={page}         // Current page (for UI)
                        onPageChange={handleChangePage}  // Handle page change
                        rowsPerPage={rowsPerPage}  // Number of records per page
                        onRowsPerPageChange={handleChangeRowsPerPage}  // Handle rows per page change
                        rowsPerPageOptions={[12, 24, 48]}  // Options for rows per page
                    />
                </div>
            </div>
            <Footer />
            {loading && (
                <div className="loader position-absolute ">
                    (<SunspotLoader />)
                </div>
            )}
        </div>
    )
}

export default SqHistory;
